// fallback for non-array-like ES3 and non-enumerable old V8 strings
var fails = require('../internals/fails');

var classof = require('../internals/classof-raw');

var split = ''.split;
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;